module.exports = __webpack_public_path__ + "img/portugal-genitourinary-diseases-female.77af9a4c.png";